module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction: Into the City: The Changing Faces of Rome / Isabella Clough Marinaro and Bjørn Thomassen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME:")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCAL AND THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOBAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('strong', [_vm._v("1")]), _vm._v("   Diversely Global Rome / Bjørn Thomassen and Piero Vereni")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2")]), _vm._v("   The Liberal, the Neoliberal, and the Illiberal: Dynamics of Diversity and Politics of Identity in Contemporary Rome / Michael Herzfeld")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3")]), _vm._v("   Rome as a Global City: Mapping New Cultural and Political Boundaries / Pierluigi Cervelli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4")]), _vm._v("   Housing and Homelessness in Contemporary Rome / Pierpaolo Mudu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HANGING")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACES")]), _vm._v(", C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HANGING")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5")]), _vm._v("   Torpignattara/Banglatown: Processes of Reurbanization and Rhetorics of Locality in a Suburb of Rome / Alessandra Broccolini")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6")]), _vm._v("   Foreign Pupils, Bad Citizens: The Public Construction of Difference in a Roman School / Piero Vereni")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7")]), _vm._v("   Evicting Rome’s Undesirables: Two Short Tales / Isabella Clough Marinaro and Ulderico Daniele")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8")]), _vm._v("   The Rootedness of a Community of Xoraxané Roma in Rome / Marco Solimene")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9")]), _vm._v("   Ways of Living in the Market City: Bufalotta and the Porta di Roma Shopping Center / Carlo Cellamare")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" III. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TS")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACTURED")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODERNITIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10")]), _vm._v("   Roma, "), _c('em', [_vm._v("Città Sportiva")]), _vm._v(" / Simon Martin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11")]), _vm._v("   Football, "), _c('em', [_vm._v("Romanità")]), _vm._v(", and the Search for Stasis / Mark Dyal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("12")]), _vm._v("   Rome’s Contemporary Past / Valerie Higgins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" IV. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NFORMAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("13")]), _vm._v("   The Self-Made City / Carlo Cellamare")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("14")]), _vm._v("   Marginal Centers: Learning from Rome’s Periphery / Ferruccio Trabalzi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("15")]), _vm._v("   Residence Roma: Senegalese Immigrants in a Vertical Village / Cristina Lombardi-Diop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("16")]), _vm._v("   Where Is Culture in Rome? Self-Managed Social Centers and the Right to Urban Space / Pierpaolo Mudu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("17")]), _vm._v("   Greening Rome: Rediscovering Urban Agriculture / Ferruccio Trabalzi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contributors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0